<template>
  <div>
    <el-dialog
      title="修改细分类必选"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <!--工具条-->
      <el-form :model="filters" class="toolbar" ref="filters" label-width="75px">
        <el-row style="padding-bottom: 0px;">
          <el-col :span="6">
            <el-form-item label="商品大类" prop="dept">
              <el-select v-model="filters.dept" filterable placeholder="请选择" disabled>
                <el-option
                  v-for="(item,i) in goodsList"
                  :key="i"
                  :label="item.CODE + ' ' + item.NAME"
                  :value="item.CODE"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="棚格图分类" prop="spaceclassNew">
              <el-select
                v-model="filters.spaceclassNew"
                filterable
                placeholder="请选择"
                :disabled="pgtDisable"
                @change="selectTwo"
              >
                <el-option
                v-for="(item,i) in List"
                :key="i"
                :label="item"
                :value="item"
              ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="细分类" prop="ssubclass">
              <el-select v-model="filters.ssubclass" filterable placeholder="请选择">
                <el-option
                  v-for="(item,i) in ssubList"
                  :key="i"
                  :label="item.ssubclass + ' ' + item.ssubName"
                  :value="item.ssubclass"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row class="mt5">
          <el-col>
            <el-form-item class="leftNolabel">
              <el-button type="primary" @click="search()">
                <i class="el-icon-search"></i>查询
              </el-button>
              <el-button @click="submit()">提交</el-button>
              <el-button @click="reset()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 列表 -->
      <el-table
        :data="planLists"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%;"
      >
        <el-table-column prop="isdDept,isdDeptName" label="商品大类" min-width="150">
          <template slot-scope="scope">{{scope.row.isdDept}}&nbsp;{{scope.row.isdDeptName}}</template>
        </el-table-column>
        <el-table-column prop="isdPogCode,isdPogName" label="棚格图分类" min-width="150">
          <template slot-scope="scope">{{scope.row.isdPogCode}}&nbsp;{{scope.row.isdPogName}}</template>
        </el-table-column>
        <el-table-column prop="isdSsubcls,isdSsubclsName" label="细分类" min-width="150">
          <template slot-scope="scope">{{scope.row.isdSsubcls}}&nbsp;{{scope.row.isdSsubclsName}}</template>
        </el-table-column>
        <el-table-column prop="isdOldselections" label="必选数量" min-width="150"></el-table-column>
        <el-table-column prop="isdSelections" label="变更后必选数量" min-width="150">
          <template slot-scope="scope">
            <div class="pd5">
              <el-input
                v-model="scope.row.isdSelections"
                type="number"
                @input.native="handleInput($event,scope.row)"
                min="0"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isdDesc" label="变更原因" min-width="150">
          <template slot-scope="scope">
            <div class="pd5">
              <el-input
                type="text"
                v-model="scope.row.isdDesc"
                class="changeReason"
                @input.native="reasonInput($event,scope.row)"
                maxlength="120"
                disabled
              ></el-input>
              <div class="errorBox">请输入变更原因</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="totalNum>0"
        :total="totalNum"
        :page.sync="pageSize"
        :limit.sync="pageRows"
        @pagination="getRows"
      />

      <div slot="footer" class="dalog-footer">
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    },
    pogList: {
      type: Array,
      default(){
        return []
      }
    },
  },
  data: function() {
    return {
      planLists: [],
      List: [],
      goodsList: [],
      filters: {
        dept: "",
        spaceclassNew: ""
      },
      pageSize: 1,
      pageRows: 10,
      totalNum: 0,
      listLoading: false,
      ssubList: [],
      pgtDisable: false,
    };
  },
  components: {
    Pagination
  },
  created() {
    this.filters.dept = this.params.dept;
    this.List = this.pogList;
    this.filters.spaceclassNew = this.params.spaceclassNew;
    this.filters.mrId = this.params.mrId;
    if(this.filters.mrId){
      this.pgtDisable = true;
      this.filters.spaceclassNew = this.List.toString();
    }
    this.getSubList(this.filters.spaceclassNew);
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
    // getRows() {
    //   var _this = this;
    //   let para = {
    //     pageSize: _this.pageSize,
    //     pageRows: _this.pageRows,
    //     dept: _this.filters.dept,
    //     spaceclassNew: _this.filters.spaceclassNew,
    //     ssubclass: _this.filters.ssubclass,
    //     mrId: _this.filters.mrId
    //   };
    //   this.listLoading = true;
    //   this.$api.selectgoods.getSsubclassResult(para).then(res => {
    //     this.totalNum = res.data.total;
    //     this.planLists = res.data.result;
    //     for (var i = 0; i < this.planLists.length; i++) {
    //       this.$set(
    //         this.planLists[i],
    //         "iseValueChange",
    //         this.planLists[i].ssubclassRequiredNum
    //       );
    //     }
    //     console.log(this.planLists);
    //     this.listLoading = false;
    //   });
    // },
    getRows() {
      var _this = this;
      let para = {
        pageSize: _this.pageSize,
        pageRows: _this.pageRows,
        mrId: _this.filters.mrId
      };
      this.listLoading = true;
      this.$api.selectgoods.showItemssubclsDefineAlterAppDetail(para).then(res => {
        this.totalNum = res.data.total;
        this.planLists = res.data.result;
        this.listLoading = false;
      });
    },
    getGoodsCategories() {
      var _this = this;
      let para = {};
      this.$api.selectgoods.getGoodsCategories(para).then(res => {
        this.goodsList = res.data.result;
      });
    },
    getSubList(event) {
      var _this = this;
      let para = {};
      if (!(event == null || event == undefined || event == "")) {
        para = { spaceclassNew: event };
      }
      this.$api.selectgoods.getSsubclassResultBySpaceClass(para).then(res => {
        this.ssubList = res.data.result;
      });
    },
    // selectOne(event, item) {
    //   this.getList(event);
    // },
    selectTwo(event, item) {
      this.getSubList(event);
    },
    handleInput(e, row) {
      console.log(e, row);
      this.val = e.srcElement.value;
      var dataList = this.planLists;
      var listAdd = dataList.filter(item => item.isdSelections === this.val);
      dataList.ssubclassRequiredNum = listAdd[0].ssubclassRequiredNum;
      var reasonBox =
        e.srcElement.parentNode.parentNode.parentNode.parentNode.nextSibling
          .children[0].children[0].children[0].children[0];
      var errorBox = reasonBox.parentNode.nextSibling.nextSibling;
      if (this.val == dataList.ssubclassRequiredNum) {
        reasonBox.setAttribute("disabled", "true");
        reasonBox.setAttribute("style", "background-color:#E4E7ED");
      } else {
        reasonBox.removeAttribute("disabled");
        reasonBox.removeAttribute("style");
      }
      if (this.val !== dataList.ssubclassRequiredNum) {
        reasonBox.setAttribute(
          "style",
          "border-color:#e81c1c;background-color:#fff"
        );
        reasonBox.removeAttribute("disabled");
        reasonBox.parentNode.classList.remove("is-disabled");
        errorBox.setAttribute("style", "display:block");
      } else {
        reasonBox.setAttribute("style", "border-color:#DCDFE6;");
        reasonBox.setAttribute("disabled", "true");
        reasonBox.parentNode.classList.add("is-disabled");
        errorBox.setAttribute("style", "display:none");
      }
    },
    reasonInput(e, row) {
      var reasonVal = e.srcElement.value;
      if (reasonVal !== "" || reasonVal !== null || reasonVal !== undefined) {
        e.target.setAttribute("style", "border-color:#DCDFE6;");
        e.target.parentNode.nextSibling.nextSibling.setAttribute(
          "style",
          "display:none"
        );
      }
    },
    submit() {
      var _this = this;
      for (var i = 0; i < this.planLists.length; i++) {
        if ((this.planLists[i].isdSelections !== this.planLists[i].isdOldselections) && (this.planLists[i].isdDesc == null || this.planLists[i].isdDesc == "")) {
          this.$message("请输入变更原因");
          return;
        }
      }
      _this.$confirm("确定提交吗？", "提示", {}).then(() => {
        _this.listLoading = true;
        let para = {};
        let appDetails = [];
        _this.planLists.forEach(function(item) {
          if(item.ssubclassRequiredNum != item.isdSelections){
            appDetails.push({
              isdId: item.isdId,
              isdSelections: item.isdSelections,
              isdDesc: item.isdDesc
            });
          }
          
        });
        para.appDetails = window.JSON.stringify(appDetails);
        para.mrId = _this.filters.mrId;
        // console.log(para);
        _this.$api.selectgoods.getSsubclassChange(para).then(res => {
          _this.listLoading = false;
          let changeReason = document.getElementsByClassName("changeReason");
          for (var i = 0; i < changeReason.length; i++) {
            changeReason[i].children[0].style.cssText =
              "background-color:#fff;";
          }
          if (res.data.code === "0000") {
            this.$message("修改成功！");
            this.handleClose();
          } else {
            this.$message("修改失败！");
          }
        });
      });
    },
    search() {
      this.pageSize = 1;
      this.getRows();
    },
    reset() {
      this.filters.ssubclass = "";
      this.pageSize = 1;
      this.getRows();
    }
  },
  mounted() {
    this.getGoodsCategories();
    this.getRows();
  }
};
</script>
<style lang="scss" scope>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/update/ssubUpdate.vue